import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ResponsePackage } from '../models/util.model';
import { SubstationTemplateDto } from '../models/network-structure.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class SubstationTemplateService {
  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'substationTemplate/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  addSubstationTemplate(dataIn: any) {
    return this.http.post(`${this.pathApi}addSubstationTemplate`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  updateSubstationTemplate(dataIn: any) {
    return this.http.post(`${this.pathApi}updateSubstationTemplate`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }
  
  getAll(utilityId: number) {
    return this.http.post(`${this.pathApi}getAll`, utilityId, {
      headers: this.headers,
      observe: 'response',
    })
  }

  get(dataIn: any) {
    return this.http.post(`${this.pathApi}get`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAllForSelect() {
    return this.http.get<ResponsePackage<SubstationTemplateDto[]>>(`${this.pathApi}getAllForSelect`, {
      headers: this.headers,
      observe: 'response',
    })
  }

  getAllForSelectByUtility(utilityId: number) {
    return this.http.get<ResponsePackage<SubstationTemplateDto[]>>(`${this.pathApi}getAllForSelectByUtility/${utilityId}`, {
      headers: this.headers,
      observe: 'response',
    })
  }

  getAllForSidebar(utilityId: number){
    return this.http.get<ResponsePackage<SubstationTemplateDto[]>>(`${this.pathApi}getAllForSidebar?utilityId=${utilityId}`, {
      headers: this.headers,
      observe: 'response',
    })
  }

  saveSchematicLayoutJson(dataIn: any) {
    return this.http.post(`${this.pathApi}saveSchematicLayoutJson`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getSchematicLayoutJsonById(dataIn: any) {
    return this.http.post(`${this.pathApi}getSchematicLayoutJsonById`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }
  getEquipmentCnt(id: number) {
    return this.http.get<ResponsePackage<boolean>>(
      `${this.pathApi}getEquipmentCount/${id}`,
      {
        headers: this.headers,
        observe: 'response',
      },
    );
  }
}
